import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { tenantQueries } from "@surgia/api/src/queryStore/admin/tenant";
import { formatDateWithMoment } from "@surgia/utils";
import { getContactName } from "@surgia/utils";

interface UseGetTenantsParams {
  currentPage: number;
  search: string;
  filters: {
    id?: string;
    city?: string;
    type?: string;
    created_at_from?: string;
    created_at_to?: string;
  };
  size?: number;
  sort?: string;
  enabled?: boolean;
}

export const useGetTenants = ({
  currentPage,
  search,
  filters,
  size = 8,
  sort,
  enabled = true,
}: UseGetTenantsParams) => {
  return useQuery({
    ...tenantQueries.queries.tenants({
      page: currentPage,
      size,
      status: "ACTIVE",
      name: search,
      id: filters.id ? +filters.id : undefined,
      city_id: filters.city,
      type: filters.type,
      created_at_from: filters.created_at_from,
      created_at_to: filters.created_at_to,
      sort: sort,
      component_id: Number(import.meta.env.VITE_HUB_COMPONENT_ID),
    }),
    placeholderData: keepPreviousData,
    select: (data) => ({
      ...data,
      data: data.data.map((tenant) => ({
        ...tenant,
        contact_person_full_name: getContactName(tenant),
        id: tenant.id?.toString(),
        tenantName: tenant.name,
        type: tenant.tenant_type,
        city: tenant.city?.name || "Unknown",
        numberOfBranches: tenant.branches?.length || 0,
        status:
          (tenant.status?.toLowerCase() as "active" | "pending" | "inactive") ||
          "pending",
        discount: tenant.discount_percentage || 0,
        contactName: getContactName(tenant),
        contactDetails: {
          email: tenant.contact_person_email || "",
          phone: tenant.contact_person_mobile || "",
        },
        dateCreated: formatDateWithMoment(tenant?.created_at),
      })),
    }),
    enabled,
  });
};
